import { render, staticRenderFns } from "./RecoveryPayment.vue?vue&type=template&id=1d5bd9e6&scoped=true&"
import script from "./RecoveryPayment.vue?vue&type=script&lang=js&"
export * from "./RecoveryPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5bd9e6",
  null
  
)

export default component.exports